
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class IncomeTaxSlabDetailsDialog extends _Ext.EditorDialogBase<IncomeTaxSlabDetailsRow> {
        protected getFormKey() { return IncomeTaxSlabDetailsForm.formKey; }
        protected getIdProperty() { return IncomeTaxSlabDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return IncomeTaxSlabDetailsRow.localTextPrefix; }
        protected getNameProperty() { return IncomeTaxSlabDetailsRow.nameProperty; }
        protected getService() { return IncomeTaxSlabDetailsService.baseUrl; }
        protected getDeletePermission() { return IncomeTaxSlabDetailsRow.deletePermission; }
        protected getInsertPermission() { return IncomeTaxSlabDetailsRow.insertPermission; }
        protected getUpdatePermission() { return IncomeTaxSlabDetailsRow.updatePermission; }

        protected form = new IncomeTaxSlabDetailsForm(this.idPrefix);

    }
}